import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    token: "",
    courseType: [],
    readCount: 1
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setToken(state, token) {
      state.token = token;
    },
    setReadCount(state) {
      state.readCount++;
    },
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      return new Promise(resolve => {
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        commit('setUserInfo', userInfo)
        resolve()
      })
    },
    setToken({ commit }, token) {
      return new Promise(resolve => {
        localStorage.setItem("token", token);
        commit('setToken', token)
        resolve()
      })
    },
    setReadCount({ commit }) {
      return new Promise(resolve => {
        commit('setReadCount')
        resolve()
      })
    },
    resetLogin({ commit }) {
      return new Promise(resolve => {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        commit('setUserInfo', {})
        commit('setToken', '')
        resolve()
      })
    },
  },
  modules: {

  }
})
